export const SUPPORT_EMAIL = 'support@intellispaceai.com';
